<template>
  <div class="panel granary-right-panel">
    <div class="chart-box">
      <!--
      <div class="tab-box flex">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          class="tab-item"
          :class="{ active: active === index }"
          @click="changeType(index)"
        >
          <span>{{ item }}</span>
        </div>
      </div> -->
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/yyczData";
import { findQueryList } from "@/api/granary";
export default {
  data() {
    return {
      // typeList: ["开证量", "生猪数量", "肉品重量"],
      active: 0
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changeType(index) {
      this.active = index;
      this.getData();
    },
    getData() {
      this.chart = this.$echarts.init(this.$refs.chart);
      findQueryList({
        code: "czbhqs"
      }).then(res => {
        const data = res.data;
        if (data instanceof Array) {
          let yearlist = [];
          let czData = [];

          data.forEach(ele => {
            yearlist.push(ele.year);
            czData.push(Number(ele.cz));
          });
          let max = Math.max(...czData);
          max = parseInt(max * 1.2);
          console.log("max", max);
          loadChart(this.chart, yearlist, [czData], "渔业产值", "万元", max, 0);
        }
      });

      // const yearlist = ["2015", "2016", "2017", "2018", "2019"];
      // const bflist = [728396, 818181, 892482, 959254, 1032333];
      // const bfData = [bflist];
      // const unit = "万元";
      // const max = 1200000;
      // const min = 200000;
      // loadChart(this.chart, yearlist, bfData, "渔业产值", unit, max, min);

      // const data = {
      //   year: this.year === "全部" ? "" : this.year,
      //   city: this.city === "广东省" ? "" : this.city,
      //   type: this.flm === "全部" ? "" : this.flm
      // };

      // getTop10(data).then(res => {
      //   // console.log("top10", res);
      //   if (res) {
      //     let slist = [];
      //     let line = [];
      //     res.forEach(ele => {
      //       slist.push(ele.name);
      //       line.push(Number(ele.num));
      //     });
      //     loadChart(this.chart, slist, line);
      //     window.addEventListener("resize", () => {
      //       setTimeout(() => {
      //         this.chart.resize();
      //       }, 300);
      //     });
      //   }
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    .tab-box
      position absolute
      top 10px
      right 4%
      z-index 999
      .tab-item
        color #fff
        font-size 10px
        padding-left 13px
        margin-right 20px
        position relative
        cursor pointer
        &:before
          content ' '
          // width 6px
          // height 6px
          width 12px
          height 12px
          border-radius 50%
          background #fff
          position absolute
          left 0
          top 50%
          transform translateY(-50%)
      .active
        color #0e9cff
        &:before
          background #0e9cff
</style>
